import { Injectable, Signal } from '@angular/core';
import { IGuideData, IGuideModel } from '@partners/api';
import { StateAccessService } from '../../../services';

import { Observable } from 'rxjs';
import { AuthActions, AuthSelectors, IAuthGuideState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AuthGuideStore extends StateAccessService<IAuthGuideState> {
  state$: Observable<IAuthGuideState<IGuideModel, IGuideData>>;

  readonly model$$: Signal<IGuideModel>;
  readonly data$$: Signal<IGuideData>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(AuthSelectors.otpModel);
    this.data$$ = this.stateFacade.selectSignal$(AuthSelectors.otpData);
  }

  dispatchAuthGuideReset() {
    this.stateFacade.dispatch(AuthActions.resetGuide());
  }

  /**
   * auth otp dispatches
   */
  dispatchGuideLoad() {
    this.stateFacade.dispatch(AuthActions.loadGuide());
  }
  dispatchGuideLoadSuccess() {
    this.stateFacade.dispatch(AuthActions.loadGuideSuccess());
  }
  dispatchGuideLoadFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.loadGuideFailure(error));
  }
  dispatchGuideSubmit() {
    this.stateFacade.dispatch(AuthActions.submitGuide());
  }
  dispatchGuideSubmitSuccess() {
    this.stateFacade.dispatch(AuthActions.submitGuideSuccess());
  }
  dispatchGuideSubmitFailure(error: any) {
    this.stateFacade.dispatch(AuthActions.submitGuideFailure(error));
  }
}
